// extracted by mini-css-extract-plugin
export default {"container":"receivedCost_container__7I1mK","pagination":"receivedCost_pagination__huj7F","noContents":"receivedCost_noContents__oKIYX"};